"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminStudentReportCardController = /** @class */ (function () {
    function AdminStudentReportCardController($stateParams, UsersModel, reportcard) {
        this.reportcard = reportcard;
    }
    return AdminStudentReportCardController;
}());
AdminStudentReportCardController.$inject = [
    "$stateParams",
    "UsersModel",
    "reportcard",
];
exports.default = AdminStudentReportCardController;
